module.exports = __webpack_public_path__ + "static/media/Friezer.4d81668c.mp3";